import React from "react";
import clsx from "clsx";
import { useStyles } from "./ReportQueueManagementTable.styles";
import moment from "moment";
import '../../ResponsiveTable/_responsive.table.css';
import { REPORT_QUEUE_STATUS, REPORT_QUEUE_STATUS_CODES } from "../../../constants";
import ActionCell from "./ActionCell";

const ReportQueueManagementTable = ({ results = [], onCancel, onView, deleting = {}, isCancelButtonDisabled = {}, handleAnimationEnd }) => {
  const classes = useStyles();

  const getExpirationMessage = (statusId, queuedDate) => {
    if (statusId === REPORT_QUEUE_STATUS_CODES.PROCESSING || !statusId) return "";
    
    const result = getExpirationDays(queuedDate);
    return result ? `${result.prefix} ${result.relative}` : "";
  }

  const getExpirationDays = (queuedDate) => {
    if(!queuedDate) return;
    var date = new Date(queuedDate);
    
    const expiresDate = new Date(date);
    // completed and error records expire in 3 days
    expiresDate.setDate(date.getDate() + 3);

    const now = new Date();
    
    const isPast = expiresDate < now;

    return {
      prefix: isPast ? "Expired" : "Expires",
      relative: moment(expiresDate).fromNow(),
    };
  }

  return (
    <div className={classes.tableContainer}>  
    <table className={clsx("a1-responsive")}>     
        <thead className={clsx(classes.thHeader)}>
          <tr>
            <th className={clsx(classes.resultHeader)}>Report Name</th>
            <th className={clsx(classes.centerHeader)}>Queued</th>
            <th className={clsx(classes.centerHeader)}>Status</th>
            <th className={clsx(classes.centerHeader)}>By</th>
            <th className={clsx(classes.centerHeader)}>Action</th>
          </tr>
        </thead>

        <tbody>
          {results.map((result) =>  {

            return (
            <tr
              key={result.id}
              data-testid="reportqueue-row"
              className={clsx({ "animate__animated animate__fadeOutUp": deleting[result.rqId] })}
              onAnimationEnd={(e) => handleAnimationEnd(result.id)}
            >
              <td
                data-column="Report Name"
              >                           
                <span className={clsx([classes.left])}>{result.reportParameters?.reportname}</span>  
                <span className={clsx([classes.expired])}>{getExpirationMessage(result.rqStatusId, result.rqCompletionTime)}</span>            
              </td>
              <td
                data-column="Queued"
                className={clsx([classes.centerAlign])}
              >
                {result?.rqCreatedTime ? moment(result.rqCreatedTime).format("MM/DD/YYYY HH:mm:ss") : ""}
              </td>
              <td
                data-column="Status"
                className={clsx([
                  classes.status, 
                  REPORT_QUEUE_STATUS[result?.rqStatusId]?.toLowerCase().replace(/\s+/g, "-")
                ])}
              >
                {
                  result?.rqStatusId 
                  && [
                    REPORT_QUEUE_STATUS_CODES.REPORT_SERVICE_ERROR, 
                    REPORT_QUEUE_STATUS_CODES.UNKNOWN_ERROR, 
                    REPORT_QUEUE_STATUS_CODES.FAILED_TO_SAVE
                  ].includes(result.rqStatusId)
                  ? "Error"
                  : result?.rqStatusId
                  ? REPORT_QUEUE_STATUS[result.rqStatusId]
                  : "Queued"
                }
              </td>
              <td
                data-column="By"
                className={clsx([classes.centerAlign])}
              >
                {result.userName}
              </td>
              <td
                data-column="Action"
                className={clsx([classes.centerAlign])}
              >
                <ActionCell 
                  statusId={result.rqStatusId}
                  onCancel={() => onCancel(result.rqId)}
                  onView={() => onView(result.rqId)}
                  isCancelling={!!isCancelButtonDisabled[result.rqId]}
                />
              </td>     
            </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ReportQueueManagementTable;
